var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "observe-visibility",
            rawName: "v-observe-visibility",
            value: function (isVisible) {
              return _vm.handleVisibilityChange(isVisible, "property")
            },
            expression:
              "\n      isVisible => handleVisibilityChange(isVisible, 'property')\n    ",
          },
        ],
        attrs: { id: "property-container" },
      },
      [
        _c("property", {
          attrs: {
            "current-application": _vm.currentApplication,
            "edit-visibility": _vm.editVisibility,
          },
          on: {
            save: _vm.handleSave,
            "toggle-visibility": _vm.handleVisibility,
            replicate: _vm.handleReplicate,
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "observe-visibility",
            rawName: "v-observe-visibility",
            value: function (isVisible) {
              return _vm.handleVisibilityChange(isVisible, "mortgage-details")
            },
            expression:
              "\n      isVisible => handleVisibilityChange(isVisible, 'mortgage-details')\n    ",
          },
        ],
        ref: "mortgageDetailsContainer",
        attrs: { id: "mortgage-details-container" },
      },
      [
        _c("mortgage-details", {
          attrs: {
            "current-application": _vm.currentApplication,
            "edit-visibility": _vm.editVisibility,
            "client-username": _vm.clientUsername,
          },
          on: {
            save: _vm.handleSave,
            "toggle-visibility": _vm.handleVisibility,
            replicate: _vm.handleReplicate,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }